__webpack_public_path__ = __IRONSCALES_PUBLIC_PATH_HACK__
